import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Email from '@material-ui/icons/MailOutline';
import LockOutline from '@material-ui/icons/LockOutlined';
import Button from 'components/core/CustomButtons/Button';
import AuthField from 'components/core/AuthField';
import LoginStyle from 'assets/jss/views/LoginStyle';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import axios from 'axios';
import compose from 'recompose/compose';
import Swal from 'sweetalert2';

class ResetPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      passwordConf: '',
    };

    this.handleEmailResetChange = this.handleEmailResetChange.bind(this);
    this.handlePasswordResetChange = this.handlePasswordResetChange.bind(this);
    this.handlePasswordResetConfChange = this.handlePasswordResetConfChange.bind(this);
    this.handleSearchTermSubmit = this.handleSearchTermSubmit.bind(this);
  }

  handleEmailResetChange(evt) {
    this.setState({ email: evt.target.value });
  }

  handlePasswordResetChange(evt) {
    this.setState({ password: evt.target.value });
  }

  handlePasswordResetConfChange(evt) {
    this.setState({ passwordConf: evt.target.value });
  }

  handleSearchTermSubmit(e) {
    e.preventDefault();
    const email = this.state.email;
    const password = this.state.passwordConf;
    const passwordConfirmation = this.state.password;

    const url = process.env.REACT_APP_API_URL;

    const token = window.location.href.split('/').pop();

    const axiosConfig = {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'Access-Control-Allow-Origin': '*',
      },
    };

    axios
      .post(
        `${url}/v1/password/reset`,
        {
          token,
          email,
          password,
          password_confirmation: passwordConfirmation,
        },
        axiosConfig,
      )
      .then(() => {
        Swal.fire({
          title: 'تم انشاء الحساب',
          text:
            'تم إنشاء وتهيئة كلمة المرور بنجاح, الرجاء الذهاب الى الصفحة الرئيسية للدخول على حسابك',
          type: 'success',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'حسنا',
        }).then(() => {
          this.props.history.push('/');
        });
      });
  }

  render() {
    const { classes } = this.props;
    return (
      <form className={classes.loginBox} onSubmit={this.handleSearchTermSubmit}>
        <p className={classes.formTitle}>إعادة ضبط كلمة المرور</p>
        <p className={classes.formSubtitle}>أدخل بياناتك لتعيين كلمة مرور جديدة</p>
        <div className={classes.fields}>
          <AuthField
            label="البريد الإلكتروني"
            id="emailReset"
            type="email"
            value={this.state.email}
            onChange={this.handleEmailResetChange}
            autoFocus
            icon={<Email />}
          />
          <AuthField
            label="الرقم السري"
            id="passwordReset"
            type="password"
            value={this.state.password}
            onChange={this.handlePasswordResetChange}
            icon={<LockOutline />}
          />
          <AuthField
            label="تأكيد الرقم السري"
            id="passwordResetConf"
            type="password"
            value={this.state.passwordConf}
            onChange={this.handlePasswordResetConfChange}
            icon={<LockOutline />}
          />
        </div>
        <div className={classes.submitRow}>
          <Button type="submit" color="primary" className={classes.submitBtn}>
            حسناً
          </Button>
        </div>
      </form>
    );
  }
}

ResetPassword.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.shape({ push: PropTypes.func.isRequired }).isRequired,
};
export default compose(
  withStyles(LoginStyle),
  connect(),
)(ResetPassword);
